/* @flow */

/**
 * External dependencies
 */
import { CSSTransition as SingleTransition } from 'react-transition-group';
import { isFunction } from 'lodash';
import React, { Component } from 'react';

/**
 * Flow
 */
export type Status = null | 'enter' | 'entered' | 'entering' | 'exit' | 'exiting' | 'exited';

type Props = {
	children: any,
};

type State = {
	status: Status,
};

export default class Transition extends Component<Props, State> {
	state = {
		status: null,
	};

	renderChild() {
		const { children, ...childProps } = this.props;

		if ( isFunction( children ) ) {
			return children( this.state.status, childProps );
		}

		return this.props.children;
	}

	render() {
		return (
			<SingleTransition
				onEnter={ () => this.setState( { status: 'enter' } ) }
				onEntered={ () => this.setState( { status: 'entered' } ) }
				onEntering={ () => this.setState( { status: 'entering' } ) }
				onExit={ () => this.setState( { status: 'exit' } ) }
				onExiting={ () => this.setState( { status: 'exiting' } ) }
				onExited={ () => this.setState( { status: 'exited' } ) }
				classNames="faker"
				timeout={ 500 }
				{ ...this.props }
			>
				{ this.renderChild() }
			</SingleTransition>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/transition/index.js